/* global ViewerUI */
/* global $ */

(function (scope) {
  "use strict";

  var PrintViewer2DView = (scope.PrintViewer2DView = function (
    controller,
    design
  ) {
    this.controller = controller;
    this.design = design;

    this.$el = $("#PrintViewerView");
    this.$document = $(document);
    this.defaultViewerWidth = this.$el.width();
    this.defaultViewerHeight = this.$el.height();
    this.offsetTopBottom =
      $("#main_menu").outerHeight() +
      $("#PrintToolbarView").height() +
      $("#PrintInformationsView").height() +
      30; // 30 for 3*10px of padding

    $(window).on("resize", this.resize.bind(this));
  });

  /**
   * go to top
   */
  PrintViewer2DView.prototype.scrollTop = function () {
    this.$document.scrollTop(0);
  };

  PrintViewer2DView.prototype.resize = function () {};
})((window.sculpteo = window.sculpteo || {}));
